var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCoinsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5436_9883)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -441,
    width: 375,
    height: 812,
    rx: 30,
    fill: "#FCF9FB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 642,
    transform: "translate(-25 -351)",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 363,
    transform: "translate(-25 -72)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 7,
    fill: "#48AE34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 26.3594V28C10 29.4062 13.3594 30.5 17.5 30.5C21.6406 30.5 25 29.4062 25 28V26.3594C23.3594 27.4922 20.4297 28 17.5 28C14.5312 28 11.6016 27.4922 10 26.3594ZM22.5 15.5C26.6406 15.5 30 14.4062 30 13C30 11.6328 26.6406 10.5 22.5 10.5C18.3594 10.5 15 11.6328 15 13C15 14.4062 18.3594 15.5 22.5 15.5ZM10 22.2578V24.25C10 25.6562 13.3594 26.75 17.5 26.75C21.6406 26.75 25 25.6562 25 24.25V22.2578C23.3594 23.5859 20.4297 24.25 17.5 24.25C14.5312 24.25 11.6016 23.5859 10 22.2578ZM26.25 22.6875C28.4766 22.2578 30 21.4375 30 20.5V18.8594C29.0625 19.4844 27.7344 19.9141 26.25 20.1875V22.6875ZM17.5 16.75C13.3594 16.75 10 18.1562 10 19.875C10 21.6328 13.3594 23 17.5 23C21.6406 23 25 21.6328 25 19.875C25 18.1562 21.6406 16.75 17.5 16.75ZM26.0547 18.9766C28.3984 18.5469 30 17.7266 30 16.75V15.1094C28.5938 16.0859 26.2109 16.5938 23.7109 16.75C24.8438 17.2969 25.7031 18.0391 26.0547 18.9766Z",
    fill: "#75C364"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5436_9883"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -441,
    width: 375,
    height: 812,
    rx: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCoinsIcon);
export default __webpack_public_path__ + "static/media/greenCoinsIcon.0d9cc992.svg";
export { ForwardRef as ReactComponent };